export default "__VITE_ASSET__SIfqC5dA__"